module.exports = __webpack_public_path__ + "media/0005.fd45627d.mp3";